import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import ZoomIn from '../Icons/ZoomIn';
import ZoomOut from '../Icons/ZoomOut';
import Reload from '../Icons/Reload';
import ColorSF2 from '../../styles/common/ColorSF2';

const Wrapper = styled.div`
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
const ButtonLabel = styled.div`
  font-size: 10px;
  margin-left: 10px;
  color: ${props => props.color};
`;

/**
 * ビデオ画面ズーム操作用のボタンを表示するコンポーネント
 * - ボタンは、ズームイン、ズームアウト、リセットの3種類
 *
 * @class
 * @property {string} type - ボタンのタイプ('expand', 'contract', 'reset'のいずれか)
 * @property {Function} action - ボタンがクリックされた際に実行されるコールバック関数
 */
class ZoomButton extends Component {
  constructor(props) {
    super(props);
    // コンポーネント内で有効なステートを定義する
    this.state = {
      click: false,
    };
  }

  componentWillUnmount() {
    this.setState({ click: false });
    this.clearTimer();
  }

  setTimer() {
    if (this.timerHandle) {
      // Exception?
      return;
    }
    // Remember the timer handle
    this.timerHandle = setTimeout(() => {
      this.setState({ click: false });
      this.timerHandle = 0;
    }, 500);
  }

  clearTimer() {
    // Is our timer running?
    if (this.timerHandle) {
      // Yes, clear it
      clearTimeout(this.timerHandle);
      this.timerHandle = 0;
    }
  }

  render() {
    const { action, type } = this.props;
    const { click } = this.state;
    const func = () => {
      action();
      this.setState({ click: true });
      this.setTimer();
    };
    const color = click ? ColorSF2.black : ColorSF2.navyBlue;
    const size = '24px';
    return (
      <Wrapper className="button" onClick={() => func()}>
        {type === 'expand' && (
          <ZoomIn color={color} width={size} height={size} />
        )}
        {type === 'contract' && (
          <ZoomOut color={color} width={size} height={size} />
        )}
        {type === 'reset' && (
          <Reload color={color} width={size} height={size} />
        )}
        <ButtonLabel color={color}>
          <FormattedMessage id={`remotePage.button.label.zoom.${type}`} />
        </ButtonLabel>
      </Wrapper>
    );
  }
}

ZoomButton.propTypes = {
  type: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default ZoomButton;
